import { render, staticRenderFns } from "./SharableContent.vue?vue&type=template&id=4c857682&scoped=true&"
import script from "./SharableContent.vue?vue&type=script&lang=js&"
export * from "./SharableContent.vue?vue&type=script&lang=js&"
import style0 from "./SharableContent.vue?vue&type=style&index=0&id=4c857682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c857682",
  null
  
)

export default component.exports